import type { PresetKey } from '../lib/weather';
import { BALANCED_SLIDER, PRESET_SLIDER, useAppStore } from '../state/store';
import { IconShade, IconSparkles } from './Icons';
import { Segmented, type SegmentOption } from './Segmented';

type ShadePreset = PresetKey | 'balanced';

const OPTIONS: SegmentOption<ShadePreset>[] = [
  { value: 'fast', label: 'Veloce' },
  { value: 'balanced', label: 'Bilanciato' },
  { value: 'auto', label: 'Consigliato' },
  { value: 'max', label: 'Max ombra' },
];

export function ShadeControl() {
  const mode = useAppStore((s) => s.mode);
  const sliderPct = useAppStore((s) => s.sliderPct);
  const setSlider = useAppStore((s) => s.setSlider);
  const applyPreset = useAppStore((s) => s.applyPreset);

  const active: ShadePreset | null =
    mode === 'auto'
      ? 'auto'
      : sliderPct === PRESET_SLIDER.fast
        ? 'fast'
        : sliderPct === BALANCED_SLIDER
          ? 'balanced'
          : sliderPct === PRESET_SLIDER.max
            ? 'max'
            : null;

  return (
    <div className="control">
      <div className="control__head">
        <span className="control__icon">
          <IconShade size={15} />
        </span>
        <span className="control__title">Ombra</span>
        <span className="control__value t-num">
          {mode === 'auto' ? (
            <>
              <IconSparkles size={13} /> automatico
            </>
          ) : (
            `${sliderPct}% priorità`
          )}
        </span>
      </div>
      <Segmented<ShadePreset>
        value={active}
        options={OPTIONS}
        onChange={(v) => applyPreset(v)}
        ariaLabel="Quanta ombra vuoi"
      />
      {mode === 'auto' ? (
        <p className="control__note">
          Provo più compromessi e scelgo quello con il miglior rapporto ombra/deviazione (al massimo
          +60% di strada).
        </p>
      ) : (
        <div className="shade-slider">
          <input
            type="range"
            className="slider"
            min={0}
            max={100}
            step={5}
            value={sliderPct}
            aria-label="Priorità dell'ombra rispetto alla distanza"
            onChange={(e) => setSlider(Number(e.target.value))}
          />
          <div className="shade-slider__scale">
            <span>Più corto</span>
            <span>Più ombra</span>
          </div>
        </div>
      )}
    </div>
  );
}
